import React from 'react';

import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';
import { NumStepper } from '@nerdwallet/react-stepper';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../lib/selectors/home-affordability-calculator-selectors';
import {
  HomeAffordabilityInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../lib/utils';
import { monthlyDebtValidations } from '../validations';
import { debouncedTrackInputEvent } from '../../../lib/analytics/trackers';
import useAnalytics from '../../../lib/analytics/use-analytics';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const MonthlyDebtInput: React.FC<HomeAffordabilityInput> = ({
  manualInputs,
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  inputType = 'TEXT',
}) => {
  const segmentAbstract = useAnalytics();
  const placeholder = num.formatCurrency(inputs?.monthlyDebt);

  const value =
    inputType === INPUT_TRACKING_TYPES.TEXT
      ? manualInputs?.monthlyDebt ?? ''
      : inputs?.monthlyDebt ?? placeholder;

  const errorMessage = validations?.monthlyDebt?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'monthlyDebt',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_type: 'increment-decrement-user_type_input',
        entityName: 'minimum_monthly_debt',
        field: 'Minimum Monthly Debt',
        field_value: e,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'monthlyDebt',
      calculator: HOME_AFFORDABILITY,
      inputType: 'currency',
    });
  };

  if (inputType === INPUT_TRACKING_TYPES.RANGE) {
    return (
      <NumStepper
        editable
        formatter="$0,0"
        min={monthlyDebtValidations.min}
        stepSize={monthlyDebtValidations.stepSize}
        value={value}
        onChange={onInputChange}
        fieldName="monthlyDebt"
      />
    );
  }

  return (
    <InputMoney
      label={label}
      value={value}
      placeholder={placeholder}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(MonthlyDebtInput);
